import { Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-fields',
  templateUrl: './formly-fields.component.html',
  styleUrl: './formly-fields.component.scss',
  imports: [FormlyModule],
})
export class FormlyFieldsComponent extends FieldType {}
